/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FacebookPixels from './FacebookPixels';

const AnalyticTools = () => {
  const location = useLocation();

  useEffect(() => {
    FacebookPixels.pageView();
  }, [location.pathname]);

  return <></>;
};

AnalyticTools.propTypes = {};

export default AnalyticTools;
